import { Button, Form, Modal, TimePicker } from "antd";

import { useForm } from "antd/es/form/Form";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { completeReview } from "../../../../redux/JobModule/QCDetailPage/QCDetailPageAction";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { useEffect, useState } from "react";
import { convertToDayjsObject } from "../../../../utils/convertSecondToHour";
import { set } from "lodash";

interface CompletedReviewModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}
function CompletedReviewModal(props: CompletedReviewModalProps) {
  //Modal Close Reseting the Fields
  const idPack = useSelector(
    (state: RootState) => state.qCDetailPageState.data.idPack
  );
  const completeReviewLoading = useSelector(
    (state: RootState) => state.qCDetailPageState.completedReviewLoading
  );
  const currentQcTime = useSelector(
    (state: RootState) => state.qCDetailPageState.data.qcTime
  );
  const [qcTime, setQcTime] = useState("00:00:00");
  const [error, setError] = useState<string>("");

  const handleModalClose = () => {
    props.close();
  };
  const [form] = useForm();
  const dispatch = useAppDispatch();
  const saveQCtime = async () => {
    const payload = {
      QcTime: qcTime,
      PackId: idPack,
    };
    try {
      await dispatch(completeReview(payload)).unwrap();
      handleModalClose();
    } catch (error) {
      setError("An error occurred while saving the QC time. Please try again.");
    }
  };
  const skipQCtime = async () => {
    const payload = {
      QcTime: "",
      PackId: idPack,
    };
    await dispatch(completeReview(payload)).unwrap();
    handleModalClose();
  };
  useEffect(() => {
    if (currentQcTime === "") {
      setQcTime("00:00:00");
    } else {
      setQcTime(currentQcTime);
    }

    return () => {
      setQcTime("00:00:00");
      form.resetFields();
      setError("");
    };
  }, [props.openState]);

  const CompletedReviewModalContent = () => {
    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content ">
        <h4> Time Tracking</h4>
        <p>
          For our records, please specify the total time you have spent auditing
          this pack.
        </p>

        <TimePicker
          className="w-100"
          needConfirm={false}
          format="HH:mm:ss"
          value={convertToDayjsObject(qcTime)}
          onChange={(time, timeString) => {
            if (time) {
              const hours = time.hour();
              const minutes = time.minute();
              const seconds = time.second();
              const formattedTime = `${String(hours).padStart(2, "0")}:${String(
                minutes
              ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
              setQcTime(formattedTime);
            } else {
              setQcTime("00:00:00");
            }
          }}
          placeholder="Select Time"
          showNow={true}
        />

        {/* <Input
              type="number"
              placeholder="Enter the QC time in hours"
              addonAfter="hours"
              onChange={(e) => {
                //convert to 00:00:00 format, if the user enters 1.52, it should be converted to 01:31:12
                const value = parseFloat(e.target.value);
                const hours = Math.floor(value);
                const minutes = Math.floor((value - hours) * 60);
                const seconds = Math.round(((value - hours) * 60 - minutes) * 60);
                const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
                setQcTime(formattedTime);
              }}
            /> */}

        {error && (
          <div className="error justify-content-end align-self-end mb-2">
            {error}
          </div>
        )}
        <div className="d-flex gap-3 justify-content-end">
          <Button
            typeof="submit"
            loading={completeReviewLoading}
            type="primary"
            onClick={() => {
              saveQCtime();
            }}
          >
            Confirm
          </Button>
          <Button
            loading={completeReviewLoading}
            className="ant-btn-primary button"
            type="primary"
            onClick={skipQCtime}
            typeof="submit"
          >
            Skip
          </Button>
          <Button
            className="cancelButton"
            loading={completeReviewLoading}
            htmlType="reset"
            onClick={handleModalClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    );
  };
  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        width={400}
        onCancel={handleModalClose}
        open={props.openState}
      >
        <CompletedReviewModalContent />
      </Modal>
    </div>
  );
}

export default CompletedReviewModal;
